import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { LoginService } from 'src/app/Common/Services/login.service';
import { ToastrService } from 'ngx-toastr';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { DashboardService } from 'src/app/Modules/dashboard/Services/dashboard.service';



export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}



@Component({
  selector: 'app-dashboard-menu',
  templateUrl: './dashboard-menu.component.html',
  styleUrls: ['./dashboard-menu.component.css']
})


export class DashboardMenuComponent implements OnInit {

  displayedColumns: string[] = ['name', 'agent','status','action'];
  dataSource ;
  ChartList :PeriodicElement[] =[];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dashboardForm:FormGroup;
  chartLists: any[] = [];
  agents:any[]=[];
  val:any;
  listofchart:any[]=[];
  
  //for show and hide of fields
  public chartname : boolean = false;
  public chartlist : boolean = true;
  public charttype : boolean = false;
  public xaxis : boolean = false;
  public yaxis : boolean = false;
  public newChart : boolean = true;
  public save : boolean = true;
  public addSave : boolean = false;
  
  public agentCtrl: FormControl = new FormControl();


  constructor(public global: GlobalService,private _formbuilder: FormBuilder,public loginservice:LoginService,private toastr: ToastrService,private dashBoardService:DashboardService) { 

    this.dashboardForm=this._formbuilder.group({
      chartList:['',[Validators.required]],
      agent:['',[Validators.required]],
      search:['']
      //chartName:['',[Validators.required]],
      //chartType:['',[Validators.required]],
     // xAxis:['',[Validators.required]],
      //yAxis:['',[Validators.required]],
    });
   
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit() {
    this.getAllLOvs("dashboard");
    this.getAllLOvs1("notification");
    this.getChartListing();

  }


  getAllLOvs(value:string){
    this.loginservice.getPageLOVs(value).subscribe((res:any)=>{
      if(res.responseBody != undefined){
        console.log("LOVs",res.responseBody);
        this.chartLists = res.responseBody.Listofcharts;
      }
    })
  }

  //for agent list 
  getAllLOvs1(value:string){
 
    this.loginservice.getPageLOVs(value).subscribe((res:any)=>{
      if(res.responseBody != undefined){
        console.log("LOVs",res.responseBody);
        this.agents = res.responseBody.agentList;
      }
    })
  }

  //To add additional charts
  // addChart(){
 
  //   this.getAllLOvs1("chartType");
  //  this.chartname = true;
  //  this.chartlist = false;
  //  this.charttype = true;
  //  this.xaxis=true;
  //  this.yaxis=true;
  //  this.newChart = false;
  //  this.save = false;
  //  this.addSave = true;
  // }

  getChartListing(){
   
    this.loginservice.getChartListing().subscribe((res:any) => {
      if(res.responseBody != undefined){
        console.log("Chart Listing :", res.responseBody);
        this.ChartList = res.responseBody.Lovlist;
        console.log("Chart Listing:", this.ChartList)
        this.dataSource = new MatTableDataSource(this.ChartList);
        this.dataSource.paginator = this.paginator;
      }
      
    })
  }



  //for list of charts save 
  chartSave(){
    
    if(this.dashboardForm.valid){
    var chartList = this.dashboardForm.value.chartList;
    var agentid = this.dashboardForm.value.agent;
    this.loginservice.chartsave(this.dashboardForm.value).subscribe((res:any) => {
      
      if(res.responseBody.validationMsg != null){
          this.toastr.success(res.responseBody.validationMsg, undefined, {
           positionClass: 'toast-bottom-right',
          timeOut: 6000
       });
       this.getChartListing();  
       this.dashboardForm.reset();      
      } 
      if(res.responseBody.ValidationMsg != null){
        this.toastr.error(res.responseBody.ValidationMsg, undefined, {
          positionClass: 'toast-bottom-right',
         timeOut: 6000
      });
      this.dashboardForm.reset();       
       }
  })
}else{
  this.toastr.error("Please Enter the Mandatory Details", undefined, {
    positionClass: 'toast-bottom-right',
   timeOut: 6000
});
}
  }


  //To edit the details
  editdetails(element){
 
    
    if(element.status == "Y"){
      var Status = "N";
    }else{
      var Status = "Y";
    }

   let obj = {         
    sno:element.no,
    status : Status,  
  }

    this.loginservice.chartEdit(obj).subscribe((res:any) => {
    
      if(res.responseBody.validationMsg != null){
          this.toastr.success(res.responseBody.validationMsg, undefined, {
           positionClass: 'toast-bottom-right',
          timeOut: 6000
       });
       this.getChartListing(); 
      } 
    })
  }
}
